import {
    apiConstants,
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../Utilities/Api";

class ServerCheckInApi {
    static checkInItems(checkInModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan/return`,
                requestTypes.PUT,
                JSON.stringify(checkInModel),
                apiConstants.successMessage.checkIn.CHECKIN,
            ),
        )
    }

    static searchAccessNumbers(accessNumber: string, showMessage: boolean | undefined) {
        return sendRequest(
            requestOptions(config.URL + `loan/return?accessNumber=${accessNumber}`,
                requestTypes.GET,
                null,
                showMessage ? apiConstants.successMessage.accessNumberSearch.FOUND : undefined,
            ),
        )
    }

}

const checkInApi = ServerCheckInApi;
export {checkInApi};